import React, { useRef, useState } from "react";

function ProductTable({ list, setList, loading, onEdit, onDelete, onSequenceChanged, userType, storeId, onEditPrice }) {
  const dragItem = useRef();
  const dragOverItem = useRef();
  
  // 🟢 NEW: Track which row's grip icon is currently being hovered
  const [activeDragRow, setActiveDragRow] = useState(null);

  const handleDragStart = (e, index) => {
    dragItem.current = index;
    // Delay hiding the original row slightly so the ghost image generates correctly
    setTimeout(() => {
      if (e.target) e.target.style.opacity = "0.4"; 
    }, 0);
  };

  const handleDragEnter = (e, index) => {
    dragOverItem.current = index;
  };

  const handleDragEnd = (e) => {
    if (e.target) e.target.style.opacity = "1"; // Reset opacity
    setActiveDragRow(null); // 🟢 Reset drag state

    if (dragItem.current === undefined || dragOverItem.current === undefined) return;
    if (dragItem.current === dragOverItem.current) return;

    const copyListItems = [...list];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    
    dragItem.current = undefined;
    dragOverItem.current = undefined;

    setList(copyListItems);
    onSequenceChanged(true);
  };

  if (loading) {
    return <div className="text-center my-5"><div className="spinner-border text-primary"></div></div>;
  }

  if (list.length === 0) {
    return <div className="text-center my-5 text-muted">No products found.</div>;
  }

  return (
    <div className="table-responsive mt-3">
      <table className="table table-hover align-middle">
        <thead className="table-secondary">
          <tr>
            <th style={{ width: "40px" }}></th>
            <th>Image</th>
            <th>Name</th>
            <th>Weight</th>
            <th>MRP</th>
            <th>Selling Price</th>
            <th>Seq.</th>
            <th>Status</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {list.map((prod, index) => (
            <tr 
              key={prod.product_id}
              // 🟢 THE FIX: Row is ONLY draggable if the mouse is on its grip icon
              draggable={activeDragRow === index} 
              onDragStart={(e) => handleDragStart(e, index)}
              onDragEnter={(e) => handleDragEnter(e, index)}
              onDragEnd={handleDragEnd}
              onDragOver={(e) => e.preventDefault()}
              // Removed the global cursor: grab from here
            >
              {/* 🟢 Drag Handle Column */}
              <td 
                className="text-muted text-center"
                style={{ cursor: (userType === "admin" || storeId === 1) ? (activeDragRow === index ? "grabbing" : "grab") : "default" }}
                // Turn on draggable when mouse enters, turn it off when mouse leaves
                onMouseEnter={() => (userType === "admin" || storeId === 1) && setActiveDragRow(index)}
                onMouseLeave={() => (userType === "admin" || storeId === 1) && setActiveDragRow(null)}
              >
                {(userType === "admin" || storeId === 1) ? <i className="bi bi-grip-vertical fs-5"></i> : <span>-</span>}
              </td>

              {/* Normal Data Columns */}
              <td>
                {prod.product_image ? (
                  <img src={prod.product_image} alt={prod.product_name} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "8px" }} />
                ) : (
                  <div style={{ width: "50px", height: "50px", backgroundColor: "#eee", borderRadius: "8px" }}></div>
                )}
              </td>
              <td className="fw-bold">{prod.product_name}</td>
              <td>{prod.product_weight || "N/A"}</td>
              <td>₹{prod.product_price}</td>
              <td>
                {(() => {
                  const hasBranchPrice = prod.branch_price !== null && prod.branch_price !== undefined;
                  const branchPrice = hasBranchPrice ? Number(prod.branch_price) : Number(prod.product_price || 0);
                  const discountPrice = Number(prod.product_discount_price || 0);
                  const effectivePrice = hasBranchPrice ? branchPrice : (discountPrice > 0 ? discountPrice : branchPrice);
                  return `₹${effectivePrice}`;
                })()}
              </td>
              <td>
                <span className="badge bg-light text-dark border">
                  {index + 1 + ((Number(localStorage.getItem("productPageSize")) || 10) * 0)}
                </span>
              </td>
              <td>
                <span className={`badge ${prod.is_active ? 'bg-success' : 'bg-danger'}`}>
                  {prod.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td className="text-center">
                {(userType === "admin" || storeId === 1) ? (
                  <>
                    <span className="actionView cursorP me-3 text-primary" onClick={() => onEdit(prod)} title="Edit">
                      <i className="bi bi-pencil-square fs-5"></i>
                    </span>
                    <span className="actionView cursorP text-danger" onClick={() => onDelete(prod)} title="Delete">
                      <i className="bi bi-trash fs-5"></i>
                    </span>
                  </>
                ) : (
                  <button className="btn btn-sm btn-outline-primary" onClick={() => onEditPrice(prod)} title="Edit Selling Price">
                    <i className="bi bi-currency-rupee"></i> Edit Price
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProductTable;